<div class="nav-header-backgroud container-fluid">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <img src="../../../../../assets/img/toyota-logo-red.png" class="img-alg color-D20000" alt="HCM TMMA Logo">
    </li>
    <li class="nav-item">
      <a class="nav-link color-D20000" aria-current="page"><span class="font-size-16">HCM-TMMK</span></a>
    </li>
    <li class="nav-item">
      <a class="nav-link active"><i class="bi bi-house-fill"></i></a>
    </li>
    <li class="nav-item ms-auto d-flex justify-content-center align-items-center"> 
      <a class="nav-link"><i class="img-alg bi bi-globe color-25AA00"></i></a>
    </li>
    <li class="nav-item">     
      <a class="nav-link"><i class="img-alg bi bi-person-circle color-D20000"></i></a>
    </li>
    <li class="nav-item">
      <a class="nav-link"><i class="img-alg bi bi-power color-D20000"></i></a>
    </li>
  </ul>
</div>